'use strict';

import _ from 'lodash';

const activities = require('../collections/activities');
const progressionKeys = (module.exports = {
	computing: {
		PA1: {
			DESCRIPTION: 'I know what an algorithm is and I can express simple algorithms using symbols',
			COLOUR: '#ff9ae9'
		},
		PA2: {
			DESCRIPTION: 'I know that computers need precise instructions',
			COLOUR: '#ff9ae9'
		},
		PA3: {
			DESCRIPTION: 'I can show care and precision to avoid errors',
			COLOUR: '#ff9ae9'
		},

		PP1: {
			DESCRIPTION: 'I know that users can write their own programs',
			COLOUR: '#ff9ae9'
		},
		PP2: {
			DESCRIPTION: 'I can create a simple program',
			COLOUR: '#ff9ae9'
		},
		PP3: {
			DESCRIPTION: 'I can run, check and change programs',
			COLOUR: '#ff9ae9'
		},
		PP4: {
			DESCRIPTION: 'I know that programs run by following precise instructions',
			COLOUR: '#ff9ae9'
		},
		PD1: {
			DESCRIPTION: 'I know that digital content can be represented in many forms',
			COLOUR: '#ff9ae9'
		},
		PD2: {
			DESCRIPTION:
				'I can distinguish between forms of digital content and can explain the different ways that they communicate information',
			COLOUR: '#ff9ae9'
		},

		PC1: {
			DESCRIPTION: 'I can obtain content from the world wide web using a web browser',
			COLOUR: '#ff9ae9'
		},
		PC2: {
			DESCRIPTION: 'I know the importance of keeping personal information private online',
			COLOUR: '#ff9ae9'
		},
		PC3: {
			DESCRIPTION: 'I know how to communicate safely and respectfully online',
			COLOUR: '#ff9ae9'
		},
		PC4: {
			DESCRIPTION: "I know what to do if I'm concerned about content or being contacted online",
			COLOUR: '#ff9ae9'
		},

		PI1: {
			DESCRIPTION: 'I can save and edit my file under the right name',
			COLOUR: '#ff9ae9'
		},
		PI2: {
			DESCRIPTION: 'I understand people interact with computers',
			COLOUR: '#ff9ae9'
		},
		PI3: {
			DESCRIPTION: 'I know common uses of ICT beyond the classroom',
			COLOUR: '#ff9ae9'
		},
		PI4: {
			DESCRIPTION: 'I can talk about my work and can make changes to improve it',
			COLOUR: '#ff9ae9'
		},

		YA1: {
			DESCRIPTION: 'I know that algorithms are implemented on digital devices as programs',
			COLOUR: '#ffe599'
		},
		YA2: {
			DESCRIPTION: 'I can design simple algorithms using loops, and selection i.e. if statements',
			COLOUR: '#ffe599'
		},
		YA3: {
			DESCRIPTION: 'I can use logical reasoning to predict outcomes',
			COLOUR: '#ffe599'
		},
		YA4: {
			DESCRIPTION: 'I can find and correct errors i.e. debugging, in algorithms',
			COLOUR: '#ffe599'
		},

		YP1: {
			DESCRIPTION: 'I can use arithmetic operators, if statements, and loops, within programs',
			COLOUR: '#ffe599'
		},
		YP2: {
			DESCRIPTION: 'I can use logical reasoning to predict the behaviour of programs',
			COLOUR: '#ffe599'
		},
		YP3: {
			DESCRIPTION: 'I can find and correct simple semantic errors i.e. debugging, in programs',
			COLOUR: '#ffe599'
		},
		YD1: {
			DESCRIPTION: 'I can recognise different types of data: text, number',
			COLOUR: '#ffe599'
		},
		YD2: {
			DESCRIPTION: 'I know that programs can work with different types of data',
			COLOUR: '#ffe599'
		},
		YD3: {
			DESCRIPTION: 'I can recognise that data can be structured in tables to make it useful',
			COLOUR: '#ffe599'
		},
		YC2: {
			DESCRIPTION: 'I know a range of ways to report unacceptable behaviour online',
			COLOUR: '#ffe599'
		},
		YI1: {
			DESCRIPTION: 'I can use technology independently to organise and change digital content',
			COLOUR: '#ffe599'
		},

		OA1: {
			DESCRIPTION:
				'I can design solutions (algorithms) that use repetition and two-way selection i.e. if, then and else',
			COLOUR: '#f9cb9c'
		},
		OA2: {
			DESCRIPTION: 'I can use diagrams to express solutions',
			COLOUR: '#f9cb9c'
		},
		OA3: {
			DESCRIPTION: 'I can use logical reasoning to predict outputs, showing an awareness of inputs',
			COLOUR: '#f9cb9c'
		},

		OP1: {
			DESCRIPTION: 'I can create programs that implement algorithms to achieve given goals',
			COLOUR: '#f9cb9c'
		},
		OP2: {
			DESCRIPTION: 'I can declare and assign variables',
			COLOUR: '#f9cb9c'
		},
		OP3: {
			DESCRIPTION:
				"I can use post-tested loops e.g. 'until', and a sequence of selection statements in programs, including an if, then and else statement",
			COLOUR: '#f9cb9c'
		},
		OD1: {
			DESCRIPTION: 'I understand the difference between data and information',
			COLOUR: '#f9cb9c'
		},
		OD2: {
			DESCRIPTION: 'I know why sorting data in a flat file can improve searching for information',
			COLOUR: '#f9cb9c'
		},
		OD3: {
			DESCRIPTION: 'I can use filters or can perform single criteria searches for information',
			COLOUR: '#f9cb9c'
		},
		OC3: {
			DESCRIPTION:
				'I recognise acceptable and unacceptable behaviour when using technologies and online services',
			COLOUR: '#f9cb9c'
		},
		OI2: {
			DESCRIPTION: 'I can create digital content for a purpose and share it with a wider audience',
			COLOUR: '#f9cb9c'
		},
		OI3: {
			DESCRIPTION: 'I can comment on the success of a solution to a problem shown through feedback',
			COLOUR: '#f9cb9c'
		},

		BA1: {
			DESCRIPTION: 'I can show an awareness of tasks best completed by humans or computers',
			COLOUR: '#9fc5e8'
		},
		BA2: {
			DESCRIPTION:
				'I can design solutions by decomposing a problem and create a sub-solution for each of the parts (decomposition)',
			COLOUR: '#9fc5e8'
		},
		BA3: {
			DESCRIPTION: 'I know that different solutions exist for the same problem',
			COLOUR: '#9fc5e8'
		},

		BP1: {
			DESCRIPTION:
				'I know the difference between, and can appropriately use if and if, then and else statements',
			COLOUR: '#9fc5e8'
		},
		BP2: {
			DESCRIPTION:
				'I can use a variable and relational operators within a loop to govern termination',
			COLOUR: '#9fc5e8'
		},
		BP3: {
			DESCRIPTION: 'I can design, write and debug modular programs using procedures',
			COLOUR: '#9fc5e8'
		},
		BP4: {
			DESCRIPTION:
				'I know that a procedure can be used to hide the detail with sub-solution (procedural abstraction)',
			COLOUR: '#9fc5e8'
		},
		BD1: {
			DESCRIPTION:
				'I can perform more complex searches for information e.g. using Boolean and relational operators',
			COLOUR: '#9fc5e8'
		},
		BD2: {
			DESCRIPTION:
				'I can analyse and evaluate data and information, and recognise that poor quality data leads to unreliable results, and inaccurate conclusions',
			COLOUR: '#9fc5e8'
		},
		BI1: {
			DESCRIPTION: 'I can make judgments about digital content I am creating for a given audience',
			COLOUR: '#9fc5e8'
		},
		BI2: {
			DESCRIPTION: 'I can recognise the audience when designing and creating digital content',
			COLOUR: '#9fc5e8'
		},
		BI3: {
			DESCRIPTION:
				'I understand the potential of IT for collaboration when computers are networked',
			COLOUR: '#9fc5e8'
		},
		BI4: {
			DESCRIPTION:
				'I can use criteria to evaluate the quality of solutions and identify refinements or improvements',
			COLOUR: '#9fc5e8'
		},

		PuA1: {
			DESCRIPTION: 'I know that iteration is the repetition of a process such as a loop',
			COLOUR: '#b47bff'
		},
		PuA2: {
			DESCRIPTION: 'I know that different algorithms exist for the same problem',
			COLOUR: '#b47bff'
		},
		PuA3: {
			DESCRIPTION: 'I can represent solutions using a structured notation',
			COLOUR: '#b47bff'
		},
		PuA4: {
			DESCRIPTION:
				'I can identify similarities and differences in situations and can use these to solve problems (pattern recognition)',
			COLOUR: '#b47bff'
		},

		PuP1: {
			DESCRIPTION:
				'I know that programming bridges the gap between algorithmic solutions and computers',
			COLOUR: '#b47bff'
		},
		PuP2: {
			DESCRIPTION:
				'I have practical experience of a high-level textual language, including using standard libraries when programming',
			COLOUR: '#b47bff'
		},
		PuP3: {
			DESCRIPTION:
				'I can use a range of operators and expressions e.g. Boolean, and applies them in the context of program control',
			COLOUR: '#b47bff'
		},
		PuP4: {
			DESCRIPTION: 'I can select the appropriate data types',
			COLOUR: '#b47bff'
		},
		PuD1: {
			DESCRIPTION: 'I know that digital computers use binary to represent all data',
			COLOUR: '#b47bff'
		},
		PuD2: {
			DESCRIPTION: 'I understand how bit patterns represent numbers and images',
			COLOUR: '#b47bff'
		},
		PuD3: {
			DESCRIPTION: 'I know that computers transfer data in binary',
			COLOUR: '#b47bff'
		},
		PuD4: {
			DESCRIPTION: 'I understand the relationship between binary and file size (uncompressed)',
			COLOUR: '#b47bff'
		},
		PuD5: {
			DESCRIPTION: 'I can define data types: real numbers and Boolean',
			COLOUR: '#b47bff'
		},
		PuD6: {
			DESCRIPTION: 'I can query data on one table using a typical query language',
			COLOUR: '#b47bff'
		},

		RA1: {
			DESCRIPTION:
				'I understand a recursive solution as a repeated identical solution to a smaller instance of a problem',
			COLOUR: '#c5281f'
		},
		RA2: {
			DESCRIPTION:
				'I can recognise when problems are similar and use the same algorithm to solve them',
			COLOUR: '#c5281f'
		},
		RA3: {
			DESCRIPTION:
				'I understand that different algorithms perform better or worse for the same task',
			COLOUR: '#c5281f'
		},
		RP1: {
			DESCRIPTION: 'I can use nested selection statements',
			COLOUR: '#c5281f'
		},
		RP2: {
			DESCRIPTION:
				'I can write custom functions including the use of parameters and appreciate why they are needed',
			COLOUR: '#c5281f'
		},
		RP3: {
			DESCRIPTION: 'I know the difference between procedures and functions and can use both',
			COLOUR: '#c5281f'
		},
		RP4: {
			DESCRIPTION: 'I understand and can use negation with operators',
			COLOUR: '#c5281f'
		},
		RP5: {
			DESCRIPTION: 'I can use and manipulate one dimensional data structures',
			COLOUR: '#c5281f'
		},
		RP6: {
			DESCRIPTION: 'I can detect and correct syntactical errors',
			COLOUR: '#c5281f'
		},
		RD1: {
			DESCRIPTION:
				'I understand how numbers, images, sounds and character sets use the same bit pattern',
			COLOUR: '#c5281f'
		},
		RD2: {
			DESCRIPTION: 'I can perform simple operations using bit patterns e.g. binary addition',
			COLOUR: '#c5281f'
		},
		RD3: {
			DESCRIPTION:
				'I understand the relationship between resolution and colour depth, including the effect on file size',
			COLOUR: '#c5281f'
		},
		RD4: {
			DESCRIPTION:
				'I can distinguish between data used in a simple program (a variable) and the storage structure for that data',
			COLOUR: '#c5281f'
		},
		RC2: {
			DESCRIPTION: 'I can use technologies and online services securely',
			COLOUR: '#c5281f'
		},

		BkA1: {
			DESCRIPTION:
				'I can recognise the distinction between the design of an algorithm and its expression in a programming language (and that this depends on the programming constructs available)',
			COLOUR: '#2b2b2b',
			TEXT_COLOUR: '#fff'
		},
		BkA2: {
			DESCRIPTION: 'I can evaluate the effectiveness of algorithms and models for similar problems',
			COLOUR: '#2b2b2b',
			TEXT_COLOUR: '#fff'
		},
		BkA3: {
			DESCRIPTION:
				'I can recognise where information can be filtered out when generalizing problems',
			COLOUR: '#2b2b2b',
			TEXT_COLOUR: '#fff'
		},
		BkA4: {
			DESCRIPTION: 'I can use logical reasoning to explain how an algorithm works',
			COLOUR: '#2b2b2b',
			TEXT_COLOUR: '#fff'
		},
		BkA5: {
			DESCRIPTION: 'I can represent algorithms using structured language',
			COLOUR: '#2b2b2b',
			TEXT_COLOUR: '#fff'
		},
		BkP1: {
			DESCRIPTION:
				"I appreciate the scope of a variable (e.g. a local variable can't be accessed outside its function)",
			COLOUR: '#2b2b2b',
			TEXT_COLOUR: '#fff'
		},
		BkP2: {
			DESCRIPTION: 'I understand and can use parameter passing',
			COLOUR: '#2b2b2b',
			TEXT_COLOUR: '#fff'
		},
		BkP3: {
			DESCRIPTION:
				'I understand the difference between pre-tested (while) and post-tested (until) loops and can use both',
			COLOUR: '#2b2b2b',
			TEXT_COLOUR: '#fff'
		},
		BkP4: {
			DESCRIPTION: 'I can apply a modular approach to error detection',
			COLOUR: '#2b2b2b',
			TEXT_COLOUR: '#fff'
		},
		BkC2: {
			DESCRIPTION: 'I understand the client-server model',
			COLOUR: '#2b2b2b',
			TEXT_COLOUR: '#fff'
		},
		BkI2: {
			DESCRIPTION:
				'I can effectively design and create digital artefacts for a wider or remote audience',
			COLOUR: '#2b2b2b',
			TEXT_COLOUR: '#fff'
		}
	},

	computationalThinking: {
		A1: {
			DESCRIPTION:
				'Writing instructions that if followed in a given order (sequences) achieve a desired effect',
			COLOUR: '#b6d7a8'
		},
		A2: {
			DESCRIPTION:
				'Writing instructions that use arithmetic and logical operations to achieve a desired effect',
			COLOUR: '#b6d7a8'
		},
		A3: {
			DESCRIPTION:
				'Writing instructions that store, move and manipulate data to achieve a desired effect; (variables and assignment)',
			COLOUR: '#b6d7a8'
		},
		A4: {
			DESCRIPTION:
				'Writing instructions that choose between different constituent instructions (selection) to achieve a desired effect',
			COLOUR: '#b6d7a8'
		},
		A5: {
			DESCRIPTION:
				'Writing instructions that repeat groups of constituent instructions (loops/iteration) to achieve a desired effect',
			COLOUR: '#b6d7a8'
		},
		A6: {
			DESCRIPTION:
				'Grouping and naming a collection of instructions that do a well-defined task to make a new instruction (subroutines, procedures, functions, methods)',
			COLOUR: '#b6d7a8'
		},
		A7: {
			DESCRIPTION:
				'Writing instructions that involve subroutines use copies of themselves to achieve a desired effect (recursion)',
			COLOUR: '#b6d7a8'
		},
		A8: {
			DESCRIPTION:
				'Writing sets of instructions that can be followed at the same time by different agents (computers or people) to achieve a desired effect (Parallel thinking and processing, concurrency)',
			COLOUR: '#b6d7a8'
		},
		A9: {
			DESCRIPTION: 'Writing a set of rules to achieve a desired effect (declarative languages)',
			COLOUR: '#b6d7a8'
		},
		A10: {
			DESCRIPTION: 'Using a standard notation to represent each of the above',
			COLOUR: '#b6d7a8'
		},
		A11: {
			DESCRIPTION: 'Creating algorithms to test a hypothesis',
			COLOUR: '#b6d7a8'
		},
		A12: {
			DESCRIPTION:
				'Creating algorithms that give good, though not always the best, solutions (heuristics)',
			COLOUR: '#b6d7a8'
		},
		A13: {
			DESCRIPTION:
				'Creating algorithmic descriptions of real world processes so as to better understand them (computational modelling)',
			COLOUR: '#b6d7a8'
		},
		A14: {
			DESCRIPTION:
				'Designing algorithmic solutions that take into account the abilities, limitations and desires of the people who will use them',
			COLOUR: '#b6d7a8'
		},

		E1: {
			DESCRIPTION: 'Assessing that an algorithm is fit for purpose',
			COLOUR: '#ea9999'
		},
		E2: {
			DESCRIPTION: 'Assessing whether an algorithm does the right thing (functional correctness)',
			COLOUR: '#ea9999'
		},
		E3: {
			DESCRIPTION: 'Designing and running test plans and interpreting the results (testing)',
			COLOUR: '#ea9999'
		},
		E4: {
			DESCRIPTION: 'Assessment whether the performance of an algorithm is good enough',
			COLOUR: '#ea9999'
		},
		E5: {
			DESCRIPTION: 'Comparing the performance of algorithms that do the same thing',
			COLOUR: '#ea9999'
		},
		E6: {
			DESCRIPTION: 'Making trade-offs between conflicting demands',
			COLOUR: '#ea9999'
		},
		E7: {
			DESCRIPTION: 'Assessment of whether a system is easy for people to use (usability)',
			COLOUR: '#ea9999'
		},
		E8: {
			DESCRIPTION:
				'Assessment of whether a system gives an appropriately positive experience when used (user experience)',
			COLOUR: '#ea9999'
		},
		E9: {
			DESCRIPTION: 'Assessment of any of E1 to E8 against set criteria',
			COLOUR: '#ea9999'
		},
		E10: {
			DESCRIPTION:
				'Stepping through algorithms/code step by step to work out what they do (dry run / tracing)',
			COLOUR: '#ea9999'
		},
		E11: {
			DESCRIPTION: 'Using rigorous argument to justify that an algorithm works (proof)',
			COLOUR: '#ea9999'
		},
		E12: {
			DESCRIPTION:
				'Using rigorous argument to check the usability or performance of an algorithm (analytical evaluation)',
			COLOUR: '#ea9999'
		},
		E13: {
			DESCRIPTION:
				'Using methods involving observing a system in use to assess its usability or performance (empirical evaluation)',
			COLOUR: '#ea9999'
		},
		E14: {
			DESCRIPTION: 'Judging when an algorithmic solution is good enough even if it is not perfect',
			COLOUR: '#ea9999'
		},
		E15: {
			DESCRIPTION: 'Assessing whether a solution meets the specification (criteria)',
			COLOUR: '#ea9999'
		},
		E16: {
			DESCRIPTION: 'Assessing whether a product meets general performance criteria (heuristics)',
			COLOUR: '#ea9999'
		},

		D1: {
			DESCRIPTION:
				'Breaking down artefacts (whether objects, problems, processes, solutions, systems or abstractions) into constituent parts to make them easier to work with',
			COLOUR: '#b4a7d6'
		},
		D2: {
			DESCRIPTION:
				'Breaking down a problem into simpler but otherwise identical versions of the same problem that can be solved in the same way (Recursive and Divide and conquer strategies)',
			COLOUR: '#b4a7d6'
		},

		Ab1: {
			DESCRIPTION: 'Reducing complexity by removing unnecessary detail;',
			COLOUR: '#cccccc'
		},
		Ab2: {
			DESCRIPTION:
				'Choosing a way to represent artefacts (whether objects, problems, processes or systems) to allow it to be manipulated in useful ways',
			COLOUR: '#cccccc'
		},
		Ab3: {
			DESCRIPTION:
				'Hiding the full complexity of an artefact, whether objects, problems, processes, solutions, systems (hiding functional complexity)',
			COLOUR: '#cccccc'
		},
		Ab4: {
			DESCRIPTION: 'Hiding complexity in data, for example by using data structures',
			COLOUR: '#cccccc'
		},
		Ab5: {
			DESCRIPTION: 'Identifying relationships between abstractions',
			COLOUR: '#cccccc'
		},
		Ab6: {
			DESCRIPTION: 'Filtering information when developing solutions',
			COLOUR: '#cccccc'
		},

		G1: {
			DESCRIPTION:
				'Identifying patterns and commonalities in problems, processes, solutions, or data',
			COLOUR: '#ce695f'
		},
		G2: {
			DESCRIPTION:
				'Adapting solutions or parts of solutions so they apply to a whole class of similar problems',
			COLOUR: '#ce695f'
		},
		G3: {
			DESCRIPTION: 'Transferring ideas and solutions from one problem area to another',
			COLOUR: '#ce695f'
		}
	},

	java: {
		'JV1.1': {
			DESCRIPTION: 'I understand what a class is',
			COLOUR: '#f48023'
		},
		'JV1.2': {
			DESCRIPTION: 'I understand what an object is',
			COLOUR: '#f48023'
		},
		'JV1.3': {
			DESCRIPTION: 'I understand the difference between objects and classes',
			COLOUR: '#f48023'
		},
		'JV2.1': {
			DESCRIPTION: 'I understand the basic syntax of variables',
			COLOUR: '#f48023'
		},
		'JV2.2': {
			DESCRIPTION:
				'I understand the difference among different data types and can explain in what situations I might use each (changing values)',
			COLOUR: '#f48023'
		},
		'JV2.3': {
			DESCRIPTION:
				'I understand the difference among different data types and can explain in what situations I might use each (strings)',
			COLOUR: '#f48023'
		},
		'JV2.4': {
			DESCRIPTION:
				'I understand the difference among different data types and can explain in what situations I might use each (Primitives - Booleans, char)',
			COLOUR: '#f48023'
		},
		'JV2.5': {
			DESCRIPTION:
				'I understand the difference among different data types and can explain in what situations I might use each (Primitives - int, double float, long)',
			COLOUR: '#f48023'
		},
		'JV2.6': {
			DESCRIPTION:
				'I can use a variable to represent a value that varies in my program and use operators and expressions to change the value',
			COLOUR: '#f48023'
		},
		'JV2.7': {
			DESCRIPTION: 'Using my knowledge of data types, I can declare attributes',
			COLOUR: '#f48023'
		},
		'JV2.8': {
			DESCRIPTION: 'I can declare methods in classes',
			COLOUR: '#f48023'
		},
		'JV2.9': {
			DESCRIPTION: 'I can distinguish between methods that should and should not return values',
			COLOUR: '#f48023'
		},
		'JV3.1': {
			DESCRIPTION: 'I know how to use comments to explain what lines, methods or classes do',
			COLOUR: '#f48023'
		},
		'JV3.2': {
			DESCRIPTION: 'I can explain how an If statement is used',
			COLOUR: '#f48023'
		},
		'JV3.3': {
			DESCRIPTION:
				'Using my knowledge of comparison operators, I can write a conditional expression that results in true or false',
			COLOUR: '#f48023'
		},
		'JV3.4': {
			DESCRIPTION:
				'Using my knowledge of Boolean operators, I can write a conditional expression that results in true or false',
			COLOUR: '#f48023'
		},
		'JV3.5': {
			DESCRIPTION:
				'I can explain how a conditional expression is used to control the flow of execution in a program',
			COLOUR: '#f48023'
		},
		'JV3.6': {
			DESCRIPTION: 'I can use else if to add complexity to the behaviour of an if statement',
			COLOUR: '#f48023'
		},
		'JV3.7': {
			DESCRIPTION: 'I can use switch statements as an alternative to an if statement',
			COLOUR: '#f48023'
		},
		'JV4.1': {
			DESCRIPTION:
				'Using a while loop, I change a variable as many times as I\u2019d like, or until a condition is true or false',
			COLOUR: '#f48023'
		},
		'JV4.2': {
			DESCRIPTION:
				'Using a for loop, I change a variable as many times as I\u2019d like, or until a condition is true or false',
			COLOUR: '#f48023'
		},
		'JV4.3': {
			DESCRIPTION: 'I can use branching statements to control the iteration of a loop (break)',
			COLOUR: '#f48023'
		},
		'JV4.4': {
			DESCRIPTION: 'I can use branching statements to control the iteration of a loop (continue)',
			COLOUR: '#f48023'
		},
		'JV4.5': {
			DESCRIPTION: 'I can use loops embedded within other loops',
			COLOUR: '#f48023'
		},
		'JV4.6': {
			DESCRIPTION: 'I can use a loop to solve a practical problem',
			COLOUR: '#f48023'
		},
		'JV4.7': {
			DESCRIPTION: 'I can explain the difference between a while loop and a for loop.',
			COLOUR: '#f48023'
		},
		'JV4.8': {
			DESCRIPTION:
				'I can use a loop to access each value in an array, and explain how the size (length) of the array is used in this statement',
			COLOUR: '#f48023'
		},
		'JV5.1': {
			DESCRIPTION: 'I understand how to represent many values as a collection in an array',
			COLOUR: '#f48023'
		},
		'JV5.2': {
			DESCRIPTION:
				'I can explain the benefit of using an array to store values, and under what circumstances using an array is useful',
			COLOUR: '#f48023'
		},
		'JV5.3': {
			DESCRIPTION:
				'I am able to initialize an array, and update values in an array after initialization',
			COLOUR: '#f48023'
		},
		'JV5.4': {
			DESCRIPTION:
				'I can explain what the size of an array is, and how the size (length) of an array varies',
			COLOUR: '#f48023'
		},
		'JV5.5': {
			DESCRIPTION:
				'Using my knowledge of loops, I can access each value in an array and use each in my program',
			COLOUR: '#f48023'
		},
		'JV6.1': {
			DESCRIPTION:
				'I can explain the difference between an array and an object, and why I would use one or the other to represent a collection of values',
			COLOUR: '#f48023'
		},
		'JV6.2': {
			DESCRIPTION:
				'By exploring an object, I can identify its properties and methods (behavior) and explain how that object might be used',
			COLOUR: '#f48023'
		},
		'JV6.3': {
			DESCRIPTION:
				'I am able to distinguish between a variable representing a number, string, or boolean, and an object',
			COLOUR: '#f48023'
		},
		'JV6.4': {
			DESCRIPTION:
				'I understand how to represent a thing that has many values rather than just one as an object with properties and how to use that object in my program',
			COLOUR: '#f48023'
		},
		'JV6.5': {
			DESCRIPTION:
				'I can represent behavior using object methods and use object methods to perform actions by or on an object',
			COLOUR: '#f48023'
		},
		'JV6.6': {
			DESCRIPTION:
				'I can change the value of an object property and explain why it would be desirable to do this',
			COLOUR: '#f48023'
		},
		'JV6.7': {
			DESCRIPTION:
				'I can explain the difference between an array and and object, and why I would use or the other to represent a collection of values',
			COLOUR: '#f48023'
		},
		'JV6.8': {
			DESCRIPTION: 'I understand how to create an array of objects',
			COLOUR: '#f48023'
		}
	}
});

progressionKeys.exists = function(code) {
	return !!progressionKeys.get(code);
};

progressionKeys.get = function(code) {
	for (var i in progressionKeys) {
		var v = progressionKeys[i][code];

		if (v) return v;
	}
};

progressionKeys.allKeys = function() {
	var progressionKeysList = [];

	_.each(progressionKeys, progressionCategory => {
		progressionKeysList = _.union(_.keys(progressionCategory), progressionKeysList);
	});

	return progressionKeysList;
};

progressionKeys.mergeKeysWithActivityData = function() {
	var progressionKeysMap = {};

	_.each(progressionKeys.allKeys(), key => {
		var progressionData = progressionKeys.get(key);

		progressionKeysMap[key] = progressionData;

		var progressionActivities = {};
		_.each(
			activities()
				.$find({
					active: true
				})
				.$(),
			activity => {
				progressionActivities[activity.id] = {
					videos: []
				};

				_.each(activity.videos, video => {
					var learningOutcomes = video.learningOutcomes;

					if (_.includes(learningOutcomes, key)) {
						progressionActivities[activity.id].videos.push(video.id);
					}
				});

				if (!progressionActivities[activity.id].videos.length) {
					delete progressionActivities[activity.id];
				}
			}
		);

		progressionKeysMap[key].activities = progressionActivities;
	});

	return progressionKeysMap;
};
